import { FC } from 'react';
import colors from 'constants/colors';

interface CheckCircleProps {
  size?: number;
}

export const CheckCircle: FC<CheckCircleProps> = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 22 22" fill="none" aria-hidden="true">
    <circle cx="11" cy="11" r="11" fill={colors.successGreen} />
    <path
      d="M6.5 11.5l3 3L15.5 8"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
